import { Button, Grid, Stack } from "@mui/material";
import CreateCampaignModal from "../CreateCampaignModal";
import { ConfirmationDialog } from "../../../../App/Components/ConfirmationDialog/ConfirmationDialog";
import MessageCampaignListing from "../../../Components/MessageCampaignListing";
import EmailCampaignListingState from "../State/EmailCampaignListingState";

export default function EmailCampaignListingTab() {
  const {
    getters: {
      page,
      isConfirmDeleteOpen,
      isDeleting,
      isCreateModalOpen,
      campaignData,
      campaignDataLoaded,
      isCreatingCampaign,
    },
    effects: {
      handlePageChange,
      handleDeleteConfirmClick,
      handleDeleteCancelClick,
      handleDeleteClick,
      handleCreateCampaignClick,
      handleCreateCampaignClose,
      handleCampaignEditing,
    },
  } = EmailCampaignListingState();

  return (
    <>
      <Grid container spacing={{ xs: 4, sm: 4, md: 4, lg: 6, xl: 10 }}>
        <Grid item xs={12}>
          <Stack direction="column" alignItems="stretch" sx={{ height: "100%" }}>
            <Stack direction="row" sx={{ width: "100%", mt: 1, mb: 1 }} justifyContent={"flex-end"}>
              <Button
                color="secondary"
                variant="contained"
                sx={{ height: "50px", mr: 1 }}
                onClick={handleCreateCampaignClick}
              >
                {isCreatingCampaign ? "Continue Creating" : "Create Campaign"}
              </Button>
            </Stack>
            <MessageCampaignListing
              page={page}
              campaigns={campaignData}
              campaignsLoaded={campaignDataLoaded}
              onDelete={handleDeleteClick}
              onPageChange={handlePageChange}
            />
          </Stack>
        </Grid>
      </Grid>
      <CreateCampaignModal
        isOpen={isCreateModalOpen}
        handleClose={handleCreateCampaignClose}
        onEdit={handleCampaignEditing}
      />
      <ConfirmationDialog
        cancelMessage="Cancel"
        confirmMessage={!isDeleting ? "Delete Campaign" : "Deleting..."}
        handleCancel={handleDeleteCancelClick}
        handleClose={handleDeleteCancelClick}
        handleConfirm={handleDeleteConfirmClick}
        isOpen={isConfirmDeleteOpen}
        message={"Are you sure you want to delete this campaign? This cannot be undone!"}
        title={"Confirm Deletion"}
        buttonsDisabled={isDeleting}
      />
    </>
  );
}
